import {makeAutoObservable} from 'mobx';

export class UiStore {
    snackbar: {
        message: string;
        type: 'success' | 'info' | 'warning' | 'error';
        duration: number;
        action?: {
            label: string;
            href?: string;
            onClick?: () => void;
        };
    } | null = null;
    emailDialog: boolean = false;

    constructor() {
        makeAutoObservable(this);
    }

    showSnackbar = (
        message: string,
        type: 'success' | 'info' | 'warning' | 'error',
        duration?: number,
        action?: {
            label: string;
            href?: string;
            onClick?: () => void;
        },
    ) => {
        this.snackbar = {
            message,
            type,
            duration: duration || 1,
            action,
        };
    };

    closeSnackbar = () => {
        this.snackbar = null;
    };

    toggleEmailDialog = () => {
        this.emailDialog = !this.emailDialog;
    };
}
